<template>
  <div class="wrapper">
    <div class="actBar">
      <el-button type="primary" size="small" @click="downloadApplyStudentExcel"
        >导出</el-button
      >
      &ensp; &ensp;
      <el-input
        placeholder="请输入内容"
        style="width: 400px"
        size="small"
        v-model="searchCondition[searchCondition.key]"
      >
        <el-select
          v-model="searchCondition.key"
          slot="prepend"
          placeholder="请选择"
        >
          <el-option label="姓名" value="userName"></el-option>
          <el-option label="手机号" value="mobile"></el-option>
        </el-select>
        <el-button slot="append" icon="el-icon-search" @click="getStudentList"></el-button> </el-input
      ><br />
      <el-pagination
        size="small"
        style="margin: 10px 0"
        @size-change="getStudentList"
        @current-change="getStudentList"
        :current-page.sync="searchCondition.jumpPage"
        :page-sizes="[30, 50, 100, 200]"
        :page-size.sync="searchCondition.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="searchCondition.total"
      >
      </el-pagination>
    </div>

    <div class="contentBox">
      <el-table :data="studentList" border style="width: 100%">
        <el-table-column type="index" width="50" label="序号">
        </el-table-column>
        <el-table-column prop="userName" label="姓名" width="180">
        </el-table-column>
        <el-table-column prop="mobile" label="手机" width="180">
        </el-table-column>
        <el-table-column prop="createTime" label="报名时间"> </el-table-column>
        <el-table-column prop="idCard" label="身份证"> </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  searchStudent,
  downloadApplyStudent,
} from "@/api/examination/student.js";
export default {
  data() {
    return {
      studentList: [],
      searchCondition: {
        jumpPage: 1,
        pageSize: 30,
        total: 0,
        signId: 0,
        mobile: "",
        userName: "",
        key: "userName",
      },
    };
  },
  created() {},
  mounted() {
    console.log(this.$route.query.id);
    this.searchCondition.signId = this.$route.query.id;
    this.getStudentList();
  },
  methods: {
    getStudentList() {
      searchStudent(this.searchCondition).then((data) => {
        this.searchCondition.total = data.total;
        this.studentList = data.records;
      });
    },
    downloadApplyStudentExcel() {
      window.open(
        `/bpi/sign-info/ex/applyStudents?signId=${this.searchCondition.signId}`
      );
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  border-radius: 4px;
  margin: 10px;
  background: #fff;
  padding: 10px 20px;
  .actBar {
  }
  /deep/ .el-select .el-input {
    width: 100px;
  }
}
</style>
